import { type CoreLayoutProps } from 'react-admin'
import {
  AppBar as RaAppBar,
  Box,
  Toolbar,
  Typography,
  styled
} from '@mui/material'
import React from 'react'
import headline_logo from '../../img/headline_logo.png'

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  zIndex: 1,
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  position: 'relative'
}))
const RootWithoutTitle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  zIndex: 1,
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  position: 'relative'
}))
const 
AppFrame = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'auto'
}))
const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  //   padding: theme.spacing(10),
  marginTop: '4em',
  marginLeft: '0'
}))
const ContentWithoutTitle = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  //   padding: theme.spacing(10),
  marginTop: '1em',
  marginLeft: '0'
}))
const AppBar: React.FC<{
  title: string
}> = ({ title, ...props }) => (
  <RaAppBar {...props} title={title}>
    <Toolbar>
      <Box component="img" src={'/common/img/headline_logo.png'} />
      <Typography variant="h1" sx={{
        color: '#f57800',
        fontSize: 40,
        fontWeight: 500,
        marginLeft: 5,
        padding: 2
      }}>UR入居者向けよくあるご質問</Typography>
      <Box flex="1" />
    </Toolbar>
  </RaAppBar>
)
export const Layout: React.FC<CoreLayoutProps> = ({ children }) => (
  <Root>
    <AppFrame>
      <AppBar title={'test'} />
      <Content>{children}</Content>
    </AppFrame>
  </Root>
)
export const LayoutWithoutTitle: React.FC<CoreLayoutProps> = ({ children }) => (
  <RootWithoutTitle>
    <AppFrame>
      <ContentWithoutTitle>{children}</ContentWithoutTitle>
    </AppFrame>
  </RootWithoutTitle>
)
